<template>
    <div class="d-flex flex-column page-wrapper funding">
        <page-header>
            <span v-if="editMode">{{ $t("message.edit" )}}</span> {{ $t("message.funding" )}}
        </page-header>
        <div class="container d-flex flex-column align-items-center page-container">
            <div class="d-flex flex-row justify-content-around steps-container">
                <div class="dot previous-dot"></div><!-- Identification -->
                <div class="dot previous-dot"></div><!-- Contact Info -->
                <div class="dot previous-dot"></div><!-- Other Info -->
                <div class="dot previous-dot" v-if="jointBorrower == true"/><!-- Joint Identification -->
                <div class="dot previous-dot" v-if="jointBorrower == true"/><!-- Joint Contact Info -->
                <div class="dot previous-dot" v-if="jointBorrower == true"/><!-- Joint Other Info -->
                <div class="dot previous-dot"></div><!-- Accounts -->
                <div class="dot current-dot"></div><!-- Funding -->
                <div class="dot next-dot"></div><!-- Review -->
            </div>
            <p class="explanation-text">
                We will need $5 to fund your Primary Savings Account. <strong>Please select how you will fund this account</strong>.
            </p>
            <div class="d-flex flex-column justify-content-start align-items-start form-container">
                <b-form @submit.prevent="submit" novalidate>
                    <b-form-group class="form-label" label="Funding Source">
                        <b-button-group vertical class="btn-width" :id="$id('fundingSource')"> 
                            <b-button variant="outline-primary" :pressed="option.fundsType === fundingSource" @click="selectFundingOption(option)" v-for="option in fundingOptions" :key="option.fundsType">{{ option.display }}</b-button>                                                                    
                        </b-button-group>
                        <div class="field-error-message" v-if="!$v.fundingSource.required && $v.fundingSource.$dirty">Please select your Funding Source</div>
                    </b-form-group>
                    <div v-if="fundingSource === 'ACH'">
                        <b-form-group class="form-label" label="Type of Account">
                            <b-button-group vertical  class="btn-width" :id="$id('accountType')">
                                <b-button variant="outline-primary" :pressed="accountType === 'C'" @click="selectAccountType('C')">Checking</b-button>
                                <b-button variant="outline-primary" :pressed="accountType === 'S'" @click="selectAccountType('S')">Savings</b-button>
                            </b-button-group>
                            <div class="field-error-message" v-if="!$v.accountType.required && $v.accountType.$dirty">Please select your Type of Account</div>
                        </b-form-group>
                        <b-form-group class="form-label" label="Routing Number">
                            <b-form-input type="tel" :id="$id('routingNumber')" v-model="routingNumber"/>
                            <div class="field-error-message" v-if="!$v.routingNumber.required && $v.routingNumber.$dirty">Please enter your Routing Number</div>
                            <div class="field-error-message" v-if="$v.routingNumber.required && !$v.routingNumber.numeric && $v.routingNumber.$dirty">Routing Number can only contain digits</div>
                            <div class="field-error-message" v-if="$v.routingNumber.required && $v.routingNumber.numeric && !$v.routingNumber.maxLength && $v.routingNumber.$dirty">Routing Number must be 9 digits</div>
                            <div class="field-error-message" v-if="$v.routingNumber.required && $v.routingNumber.numeric && !$v.routingNumber.minLength && $v.routingNumber.$dirty">Routing Number must be 9 digits</div>
                            <div class="field-error-message" v-if="$v.routingNumber.required && $v.routingNumber.numeric && $v.routingNumber.maxLength && $v.routingNumber.minLength && !$v.routingNumber.isValidRoutingNumber && $v.routingNumber.$dirty">Please enter a valid Routing Number</div>     
                        </b-form-group>
                        <b-form-group class="form-label" label="Account Number">
                            <b-form-input type="tel" :id="$id('accountNumber')" v-model="accountNumber" />
                            <div class="field-error-message" v-if="!$v.accountNumber.required && $v.accountNumber.$dirty">Please enter your Bank Account Number</div>
                            <div class="field-error-message" v-if="$v.accountNumber.required && !$v.accountNumber.numeric && $v.accountNumber.$dirty">Please enter a valid Bank Account Number</div>
                        </b-form-group>
                    </div>
                    <p v-if="fundingSource === 'ACH'" class="text-center">
                        <img src="@/assets/img/light/check-example.png" class="btn-width margin-top-10 margin-bottom-10" />
                    </p>
                    <div class="d-flex flex-column justify-content-between align-items-center final-action-div">
                        <b-button variant="secondary" type="submit" :for="$id('next')" class="btn btn-width">
                            <span v-if="!editMode">{{ $t("message.next" )}}</span>
                            <span v-if="editMode">{{ $t("message.saveEdit" )}}</span>
                        </b-button>
                        <b-button variant="light" @click="back()" :for="$id('back')" class="btn btn-width">
                            <span v-if="!editMode">{{ $t("message.back" )}}</span>
                            <span v-if="editMode">{{ $t("message.cancel" )}}</span>
                        </b-button>
                    </div>
                </b-form>
            </div>     
        </div>
        <page-footer />
        <b-modal ref="errorModalRef" body-text-variant="dark" header-text-variant="dark" centered ok-only ok-variant="secondary" title="Missing Information">You must fill out the required fields.</b-modal>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { required, requiredIf, numeric, minLength, maxLength } from "vuelidate/lib/validators";
import { isValidRoutingNumber } from "@/validators/validators.js";
import { mask } from 'vue-the-mask';
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
export default {
    name: "Funding",
    components: {
        Datepicker
    },
    directives: {
        mask
    },
    props: {},
    created() {
    },
    mounted: function () {
    },
    data: function() {
        return {
                fundingOptions: [
                    { display: 'ACH Transfer', fundsType: 'ACH' },
                    { display: 'Cash or Check in Branch', fundsType: 'Branch' },
                ],
            };
        },
    computed: {
        ...mapState([
            "editMode",
            "currentState",
            "creditUnion",
            "isJointApplication",
            "fundingOption",    
        ]),
        ...mapGetters([
            'primaryEmploymentHistoryInMonths',
        ]),
        creditUnionName: {
            get() {
                return this.creditUnion.name;
            }
        },
        jointBorrower: {
            get() {
                return this.isJointApplication;
            }
        },
        fundingSource: {
            get() {
                return this.fundingOption.fundsType;
            },
            set(value) {
                this.updateFundingOptionType(value);
            },
        },
        fundingDisplay: {
            get() {
                return this.fundingOption.display;
            },
            set(value) {
                this.updateFundingDisplay(value);
            }
        },
        accountType: {
            get() {
                return this.fundingOption.accountType;
            },
            set(value) {
                this.updateFundingAccountType(value);
            }
        },
        accountNumber: {
            get() {
                return this.fundingOption.accountNumber;
            },
            set(value) {
                this.updateFundingAccountNumber(value);
            }
        },
        routingNumber: {
            get() {
                return this.fundingOption.routingNumber;
            },
            set(value) {
                this.updateFundingRoutingNumber(value);
            }
        },
    },
    methods: {
        ...mapActions([
            'getIncomeTypes',
        ]),
        ...mapMutations([
            'updateFundingOptionType',
            'updateFundingDisplay',
            'updateFundingAccountType',
            'updateFundingAccountNumber',
            'updateFundingRoutingNumber',
        ]),
        selectFundingOption: function (opt) {
            this.$v.$reset();
            this.accountType = null;
            this.routingNumber = '';
            this.accountNumber = '';
            this.fundingSource = opt.fundsType;
            this.fundingDisplay = opt.display;
        },
        selectAccountType: function (opt) {
            this.accountType = opt;
        },
        async submit() {
            this.$v.$touch();
            console.log(this.$v)
            if(this.$v.$invalid) {
                this.$refs.errorModalRef.show();
            } else {
                this.$router.push("review");
            }
        },
        back() {
            if(this.editMode) {
                this.$store.replaceState(this.currentState);
                this.$router.push("review");
            } else {
                this.$router.push('accounts');
            }
        },
    },
    validations: {
        fundingSource: {
            required,
        },
        accountType: {
            required: requiredIf(function () {
                return this.fundingSource === "ACH";
            })
        },
        accountNumber: {
            required: requiredIf(function () {
                return this.fundingSource === "ACH";
            }),
            numeric
        },
        routingNumber: {
            required: requiredIf(function () {
                return this.fundingSource === "ACH";
            }),
            numeric,
            minLength: minLength(9),
            maxLength: maxLength(9),
            isValidRoutingNumber
        },
    },
};
</script>